import { withInstall } from '@sgui-plus/utils/with-install'

import PageStatus from './src/page-status.vue'

export const SgPageStatus = withInstall(PageStatus)
export default SgPageStatus

export * from './src/page-status'
